export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11700.4c5c86c5.jpg";